import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import { clearSnackbar } from "../../../../store/notification/actions";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import { ClickAwayListener } from "@material-ui/core";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function Notification() {
  const classes = useStyles();
  const open = useSelector((state) => state.notificationReducer.open);
  const message = useSelector((state) => state.notificationReducer.message);
  const type = useSelector((state) => {
    if (state.notificationReducer.type) {
      return state.notificationReducer.type;
    } else {
      return "info";
    }
  });
  const [notificationType, setNotificationType] = useState(null);
  const [listnerType, setListnerType] = useState(false);

  useEffect(() => {
    setNotificationType(type);
  }, [type]);

  function handleClose(e, reason) {
    if (
      (notificationType === "info" ||
        notificationType === "error" ||
        notificationType === "success") &&
      reason === "clickaway"
    ) {
      setListnerType(true);
      return;
    }
    clearSnackbar();
  }
  const handleClickAway = (e) => {
    if (listnerType === true) {
      clearSnackbar();
      setListnerType(false);
    }
  };
  return (
    <div className={classes.root}>
      <ClickAwayListener onClickAway={handleClickAway}>
        <Snackbar
          open={open}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          onClose={handleClose}
          TransitionComponent={(props) => <Slide {...props} direction="down" />}
        >
          <div>
            <Alert onClose={handleClose} severity={type}>
              {message}
            </Alert>
          </div>
        </Snackbar>
      </ClickAwayListener>
    </div>
  );
}
